import './Press.css';

function Press() {
  return (
    <main className='Press'>
      <h1>
        Download Press Packs:
      </h1>
      <p>
        <a href='/press/DecayPressPack.zip' download="DecayPressPack.zip">Decay Press Pack</a>
      </p>
    </main>
  );
}

export default Press;
